import { render } from "./Discounts.vue?vue&type=template&id=65cce7c6&scoped=true"
import script from "./Discounts.vue?vue&type=script&lang=js"
export * from "./Discounts.vue?vue&type=script&lang=js"

import "./Discounts.vue?vue&type=style&index=0&id=65cce7c6&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cce7c6"]])

export default __exports__